<template>
    <div class="container">
        <b-modal
            :model-value="showEdiAjustOrig"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            size="lg"
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog edit-ajuste-orig-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <!-- Campos de búsqueda (solo para adición) -->
                <div v-if="dataEdit?.cuenta == null" class="search-fields">
                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.criterio }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <div class="criterio-inputs-wrapper">
                                <b-form-input 
                                    v-model="critCuenta" 
                                    :placeholder="labels.criterioCuenta" 
                                    @input="buscaCuenta"
                                    class="form-input mb-2"
                                    style="height: 34px; font-size: 13px;"
                                />
                                <b-form-input 
                                    v-model="critDescripcion" 
                                    :placeholder="labels.criterioDescripcion" 
                                    @input="buscaDescripcion"
                                    class="form-input"
                                    style="height: 34px; font-size: 13px;"
                                />
                            </div>
                        </b-col>
                    </b-row>
                </div>

                <!-- Campo de cuenta (modo edición) -->
                <b-row v-if="dataEdit?.cuenta" class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.cuenta }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <div class="display-value">
                            {{ dataEdit?.cuenta }}
                        </div>
                    </b-col>
                </b-row>

                <!-- Campo de descripción (modo edición) -->
                <b-row v-if="dataEdit?.cuenta" class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.description }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <div class="display-value">
                            {{ dataEdit?.descripcion }}
                        </div>
                    </b-col>
                </b-row>

                <!-- Selección múltiple de cuentas (modo adición) -->
                <div v-if="dataEdit?.cuenta == null" class="accounts-section mt-2">
                    <div v-if="localListCuentasSelMul?.length > 0" class="accounts-list mt-1">
                        <div class="select-all-container mb-2">
                            <b-button 
                                size="sm"
                                style="background-color: #2e507a; border-color: #2e507a; font-size: 13px; padding: 4px 16px; border-radius: 4px; color: white;"
                                @click="toggleSelectAllOrig"
                            >
                                {{ selectAllOrig ? labels.deselectAll : labels.selectAll }}
                            </b-button>
                            <span class="ml-2 text-muted" style="font-size: 13px;">
                                {{ labels.seleccionadas }}: {{ listadoCuentasOrig?.length || 0 }}
                            </span>
                        </div>

                        <div class="custom-scroll-table" style="min-height: 180px; height: auto; max-height: 180px; overflow-y: auto;">
                            <table class="table table-sm table-hover" style="font-size: 13px; margin-bottom: 0;">
                                <thead style="position: sticky; top: 0; background: #f8f9fa; z-index: 1;">
                                    <tr>
                                        <th style="width: 100px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">{{ labels.cuenta }}</th>
                                        <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">{{ labels.description }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr 
                                        v-for="(cuenta, idx) in localListCuentasSelMul" 
                                        :key="idx + '-' + cuenta.id"
                                        @click="toggleAccountSelection(cuenta)"
                                        :class="{'table-active-blue': cuenta._selected}"
                                        style="cursor: pointer; border-radius: 8px;"
                                    >
                                        <td style="padding: 5px 8px; border-radius: 8px 0 0 8px;"><strong>{{ cuenta?.cuenta }}</strong></td>
                                        <td style="padding: 5px 8px; border-radius: 0 8px 8px 0;" :title="cuenta.descripcion">{{ cuenta?.descripcion }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div v-else-if="!loadingCuentas" class="text-center py-2" style="height: 180px; display: flex; align-items: center; justify-content: center;">
                        <span class="text-muted" style="font-size: 13px;">{{ labels.noAccountsFound }}</span>
                    </div>

                    <div v-else class="text-center py-2" style="height: 180px; display: flex; align-items: center; justify-content: center;">
                        <b-spinner small class="mr-1"></b-spinner>
                        <span style="font-size: 13px;">{{ labels.loading }}</span>
                    </div>
                </div>

                <!-- Campos de valor (modo edición) -->
                <template v-if="dataEdit?.cuenta">
                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.valor }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-input 
                                v-model="dataEdit.valor" 
                                type="number" 
                                step="0.01"
                                class="form-input"
                                style="height: 36px; font-size: 14px;"
                            />
                        </b-col>
                    </b-row>

                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.funcional }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-input 
                                v-model="dataEdit.funcional" 
                                type="number" 
                                step="0.01"
                                class="form-input"
                                style="height: 36px; font-size: 14px;"
                            />
                        </b-col>
                    </b-row>

                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.alterna }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-input 
                                v-model="dataEdit.alterna" 
                                type="number" 
                                step="0.01"
                                class="form-input"
                                style="height: 36px; font-size: 14px;"
                            />
                        </b-col>
                    </b-row>
                </template>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="mr-2 reset-btn-secondary" @click="closeModal" :disabled="isSaving" style="font-size: 14px; padding: 6px 24px;">
                        {{ labels.close }}
                    </b-button>
                    <b-button class="reset-btn-primary" @click="guardaAjuste" :disabled="isSaving" style="font-size: 14px; padding: 6px 24px;">
                        <b-spinner v-if="isSaving" small class="mr-1"></b-spinner>
                        {{ isSaving ? labels.saving : labels.save }}
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import AjustesConsol from '../../services/AjustesConsol' 

export default {
    name: "EditAjustesOrigen",
    props: {
        showEdiAjustOrig: {
            type: Boolean,
            default: false
        },
        dataEdit: {
            type: Object,
            default: () => ({})
        },
        listCuentas: {
            type: Array,
            default: () => []
        },
        listCuentasSelMul: {
            type: Array,
            default: () => []
        },
        codReporte: {
            type: [String, Number],
            default: null
        },
        idCompania: {
            type: [String, Number],
            default: null
        },
        vigencia: {
            type: [String, Number],
            default: null
        },
        secuencia: {
            type: [String, Number],
            default: null
        },
        tipo: {
            type: [String, Number],
            default: null
        },
        tipo_ajuste: {
            type: [String, Number],
            default: null
        }
    },
    data: () => ({
        critCuenta: "",
        critDescripcion: "",
        listadoCuentasOrig: [],
        selectAllOrig: false,
        isSaving: false,
        localListCuentasSelMul: [],
        loadingCuentas: false
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Editar ajuste de origen",
                    save: "Guardar",
                    saving: "Guardando...",
                    close: "Cerrar",
                    criterio: "Criterio de búsqueda",
                    criterioCuenta: "Buscar por cuenta...",
                    criterioDescripcion: "Buscar por descripción...",
                    cuenta: "Cuenta",
                    description: "Descripción",
                    valor: "Valor",
                    funcional: "Funcional",
                    alterna: "Alterna",
                    seleccionadas: "Cuentas seleccionadas",
                    selectAll: "Seleccionar todas",
                    deselectAll: "Deseleccionar todas",
                    noAccountsFound: "No se encontraron cuentas",
                    infoTitle: "Datos del ajuste de origen",
                    infoText: "Actualiza la información del ajuste de origen y guarda los cambios.",
                    loading: "Cargando cuentas..."
                }
            } else {
                return {
                    title: "Edit origin setting",
                    save: "Save",
                    saving: "Saving...",
                    close: "Close",
                    criterio: "Search criteria",
                    criterioCuenta: "Search by account...",
                    criterioDescripcion: "Search by description...",
                    cuenta: "Account",
                    description: "Description",
                    valor: "Value",
                    funcional: "Functional",
                    alterna: "Alternate",
                    seleccionadas: "Selected accounts",
                    selectAll: "Select all",
                    deselectAll: "Deselect all",
                    noAccountsFound: "No accounts found",
                    infoTitle: "Origin adjustment data",
                    infoText: "Update the origin adjustment information and save changes.",
                    loading: "Loading accounts..."
                }
            }
        }
    },
    watch: {
        listCuentasSelMul: {
            immediate: true,
            handler(newVal) {
                this.localListCuentasSelMul = newVal ? [...newVal] : []
                this.initSelectionState()
            }
        },
        listCuentas: {
            immediate: true,
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    this.localListCuentasSelMul = [...newVal]
                    this.initSelectionState()
                }
            }
        },
        showEdiAjustOrig(val) {
            if (val) {
                this.initSelectionState()
                this.loadingCuentas = false
            }
        }
    },
    methods: {
        toggleAccountSelection(cuenta) {
            cuenta._selected = !cuenta._selected
            this.onAccountChange(cuenta)
        },

        buscaCuenta() {
            if (this.critCuenta.length == 0) {
                this.localListCuentasSelMul = [...this.listCuentas]
                this.initSelectionState()
                return
            }
            const criterio = "^" + this.critCuenta
            this.localListCuentasSelMul = this.listCuentas.filter(
                (cuenta) => cuenta.cuenta && cuenta.cuenta.match(criterio)
            )
            this.initSelectionState()
        },

        buscaDescripcion() {
            if (this.critDescripcion.length == 0) {
                this.localListCuentasSelMul = [...this.listCuentas]
                this.initSelectionState()
                return
            }
            const searchTerm = this.critDescripcion.toUpperCase()
            this.localListCuentasSelMul = this.listCuentas.filter(
                (cuenta) => cuenta.descripcion &&
                    cuenta.descripcion.toUpperCase().includes(searchTerm)
            )
            this.initSelectionState()
        },

        initSelectionState() {
            if (!Array.isArray(this.localListCuentasSelMul) || this.localListCuentasSelMul.length === 0) {
                return
            }
            
            if (this.listadoCuentasOrig.length === 0 && this.dataEdit?.cuenta) {
                this.listadoCuentasOrig = [this.dataEdit.cuenta]
            }
            
            this.localListCuentasSelMul.forEach(cuenta => {
                cuenta._selected = this.listadoCuentasOrig.includes(cuenta.cuenta)
            })
            this.updateSelectAll()
        },

        toggleSelectAllOrig() {
            this.selectAllOrig = !this.selectAllOrig
            this.localListCuentasSelMul.forEach(cuenta => {
                cuenta._selected = this.selectAllOrig
                if (this.selectAllOrig && !this.listadoCuentasOrig.includes(cuenta.cuenta)) {
                    this.listadoCuentasOrig.push(cuenta.cuenta)
                } else if (!this.selectAllOrig) {
                    const index = this.listadoCuentasOrig.indexOf(cuenta.cuenta)
                    if (index > -1) {
                        this.listadoCuentasOrig.splice(index, 1)
                    }
                }
            })
        },

        onAccountChange(cuenta) {
            if (cuenta._selected && !this.listadoCuentasOrig.includes(cuenta.cuenta)) {
                this.listadoCuentasOrig.push(cuenta.cuenta)
            } else if (!cuenta._selected) {
                const index = this.listadoCuentasOrig.indexOf(cuenta.cuenta)
                if (index > -1) {
                    this.listadoCuentasOrig.splice(index, 1)
                }
            }
            this.updateSelectAll()
        },

        updateSelectAll() {
            if (!this.localListCuentasSelMul || this.localListCuentasSelMul.length === 0) {
                this.selectAllOrig = false
                return
            }
            this.selectAllOrig = this.localListCuentasSelMul.every(cuenta => cuenta._selected)
        },

        guardaAjuste() {
            if (this.isSaving) return
            
            // Validación para adición
            if (!this.dataEdit?.cuenta && this.listadoCuentasOrig.length === 0) {
                this.$toast.error("Seleccione al menos una cuenta")
                return
            }
            
            if (this.dataEdit.valor === '' || this.dataEdit.valor === null || this.dataEdit.valor === undefined) {
                this.dataEdit.valor = null
            }
            if (this.dataEdit.funcional === '' || this.dataEdit.funcional === null || this.dataEdit.funcional === undefined) {
                this.dataEdit.funcional = null
            }
            if (this.dataEdit.alterna === '' || this.dataEdit.alterna === null || this.dataEdit.alterna === undefined) {
                this.dataEdit.alterna = null
            }

            // Validaciones para edición
            if (this.dataEdit?.cuenta) {
                if (this.dataEdit.valor !== null && (this.dataEdit.funcional === null || this.dataEdit.alterna === null)) {
                    this.$toast.error("Funcional y Alterna no pueden ser nulos")
                    return
                }
                if (this.dataEdit.valor === null && (this.dataEdit.funcional !== null || this.dataEdit.alterna !== null)) {
                    this.$toast.error("Funcional y Alterna deben ser nulos")
                    return
                }
            }

            let form = {}
            if (this.dataEdit.cuenta) {
                form = {
                    'id': this.dataEdit.id,
                    'cuenta': this.dataEdit.cuenta,
                    'vigencia': this.dataEdit.vigencia,
                    'companyId': this.dataEdit.id_compania,
                    'valor': this.dataEdit.valor,
                    'funcional': this.dataEdit.funcional,
                    'alterna': this.dataEdit.alterna,
                    'secuencia': this.secuencia,
                    'idUser': this.$store.state.userId,
                }
            } else {
                form = {
                    'vigencia': this.vigencia,
                    'secuencia': this.secuencia,
                    'codReporte': this.codReporte,
                    'companyId': this.idCompania,
                    'tipo': this.tipo,
                    'listadoCuentas': this.listadoCuentasOrig,
                    'idUser': this.$store.state.userId,
                }
            }

            this.isSaving = true
            AjustesConsol.updateAjusteOrigen(form)
                .then((res) => {
                    if (res.status == 200) {
                        this.$toast.success(res.data.message || "Ajuste guardado correctamente")
                        this.reloadTbl()
                        this.closeModal()
                    }
                })
                .catch((error) => {
                    console.log(error)
                    this.$toast.error(error.response?.data?.message || "Error al guardar el ajuste de origen")
                })
                .finally(() => {
                    this.isSaving = false
                })
        },

        closeModal() {
            if (this.isSaving) return
            this.resetForm()
            this.$emit('closeModal', false)
        },

        resetForm() {
            this.critCuenta = ""
            this.critDescripcion = ""
            this.listadoCuentasOrig = []
            this.selectAllOrig = false
            this.localListCuentasSelMul = []
            this.loadingCuentas = false
        },

        reloadTbl() {
            let form = {
                'id': this.secuencia,
                'vigencia': this.vigencia,
                'idCompany': this.idCompania
            }
            this.$emit('reloadTblOrig', form)
        }
    }
}
</script>

<style src="../main.css"></style>

<style scoped>
.table-active-blue {
    background-color: #e3f0ff !important;
    border-radius: 8px !important;
}

.table-active-blue td {
    background-color: #e3f0ff !important;
}

.table-responsive .table {
    border-collapse: separate !important;
    border-spacing: 0 4px !important;
}

.table-responsive .table tbody tr {
    border-radius: 8px !important;
    box-shadow: none !important;
}

.table-responsive .table tbody tr td {
    border: none !important;
}

.table-responsive .table tbody tr:hover {
    background-color: #f5f9ff !important;
}

.table-responsive .table tbody tr:hover td {
    background-color: #f5f9ff !important;
}

.table-responsive .table td,
.table-responsive .table th {
    border: none !important;
}

.custom-scroll-table {
    height: 180px;
    min-height: 180px;
    max-height: 180px;
    overflow-y: auto;
    position: relative;
}

.custom-scroll-table::-webkit-scrollbar {
    width: 8px;
}

.custom-scroll-table::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.custom-scroll-table::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
}

.custom-scroll-table::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.criterio-inputs-wrapper {
    width: 100%;
}

.display-value {
    padding: 6px 12px;
    background-color: #f8f9fa;
    border-radius: 4px;
    border: 1px solid #e9ecef;
    font-size: 14px;
    color: #495057;
    min-height: 36px;
}
</style>